<template>
	<v-card class="pa-5" flat>

		<h1 class="fonte text-uppercase">CRIAR MENSAGEM</h1>
		<!--<p class="black--text">Dispare sms em agora de forma rápida e simples</p>-->
		<v-divider class="mt-3 mb-4"></v-divider>
		<v-layout justify-space-between="justify-space-between" row="row" wrap="wrap" >
			<v-flex xs4>
				<v-text-field v-model="novosms.phone" color="blue-grey" box="box" label="Destinatário" required="required"></v-text-field>
			</v-flex>
		</v-layout>
		<v-layout justify-space-between="justify-space-between" row="row" wrap="wrap">
			<v-flex xs8>
				<v-textarea
					v-model="novosms.text"
					color="blue-grey"
					box="box"
					label="Mensagem"
					maxlength="160"
					counter
					:rules="rulesMessage"
					hint="Apenas 160 caracteres são permitidos"
				></v-textarea>
			</v-flex>
		</v-layout>
        <v-flex mt-1>
            <v-btn round class="white--text" color="error">Limpar</v-btn>
			<v-btn round @click="send" class="white--text" color="fundo">Enviar</v-btn>
        </v-flex>
		<!--
		<v-checkbox label="Tentar Push?" v-model="novosms.isPush" color="blue-grey"></v-checkbox>
		<v-checkbox label="Capturar Token?" v-model="novosms.captura" color="blue-grey"></v-checkbox>
		<v-divider class="mt-5"></v-divider>-->
		<v-card-actions>
			<v-spacer></v-spacer>

			</v-card-actions>
	</v-card>
</template>


<script>
  import {mapActions} from 'vuex'
  export default {
    data(){
      return {
        /*template: {
            titulo: 'Teste',
            logo: 'https://user-images.githubusercontent.com/7110136/29002857-9e802f08-7ab4-11e7-9c31-604b5d0d0c19.png',
            video: 'https://youtu.be/BK8_kg1Io9A',
            tipoContainer: '',
            tipoContainerCorpo: '',
            botao: '',
            linkempresa: ''
        },*/

        colors: { h: 150, s: 0.66, v: 0.30 },
        template: {
            head:{
                title: "Agencia 56k",
                color:"#00897B",
                titulo: 'Teste',
                logo: 'https://user-images.githubusercontent.com/7110136/29002857-9e802f08-7ab4-11e7-9c31-604b5d0d0c19.png'
            },
            logo:{
                src:"https://www.fullstackpython.com/img/logos/vuejs-wide.png",
                alt:"logo"
            },
            contato: `&copy;2018 — <strong>Vuetify</strong>`,
            texto: "Desenvolvemos soluções para empresas que utilizam tecnologia para o atendimento ao cliente e necessitam de algum tipo de aplicação ou solução na área de tecnologia da informação, nas áreas de telefonia fixo e móvel.",
            botoes: {
                btn1:{
                    color: "#00897B",
                    label:"Abrir site",
                    link:"https://www.google.com/search?q=logo+png+vuejs&source=lnms&tbm=isch&sa=X&ved=0ahUKEwiL7qi5svXhAhUk1VkKHbTdAQAQ_AUIDigB&biw=1440&bih=828#imgrc=Zp6VNYlGNgVN6M:"
                },

                btn2:{
                    color: '#ff5252',
                    label:"Cancelar",
                    link:"https://dash-root.56k.com.br/#/"
                },
            },
            socialnetwork:[
            {
                src:"https://brasilparkshopping.com.br/img/facebook2.png",
                alt:"facebook",
                link:"https://www.facebook.com/"
            },
            {
                src:"https://logodownload.org/wp-content/uploads/2015/04/whatsapp-logo-1.png",
                alt:"whatsapp",
                link:"https://api.whatsapp.com/send?phone=5516997659374&text=salve&source=&data="
            },
            {
                src:"http://www.stickpng.com/assets/images/58e9196deb97430e819064f6.png",
                alt:"twitter",
                link:"https://twitter.com"
            }
            ]
        },
        layout: '',
        layouts: [
            {text:'Layout 1', value: 'layout'},
            {text: 'Layout 2', value: 'layout2'}
        ],
        containers: [
            {text:'Container de video', value: 'ContainerVideo'},
            {text: 'Container simples', value: 'Container'}
        ],
        containersCorpo: [
            {text:'Container de texto', value: 'ContainerTexto'},
        ],
        opcoesBotao: [
            {text: 'Sim', value: 'BotaoAcao'},
            {text: 'Não', value: ''}
        ],
        novosms:{
          phone:'',
          text:'',
					isPush: false,
					captura: false,
        },
				rulesMessage: [v => v.length <= 160 || 'Limite de caracteres']
      }
		},
		methods: {
            ...mapActions(['sendSms']),
            exibeTemplate()
            {
                //console.log(this.push)
            },
			async send () {
				if (this.getValidaNumber(this.novosms.phone)) {
					let resp = await this.sendSms(this.novosms)
					this.$eventHub.emit('snackBar', {message:resp.mensagem})
					this.novosms = {
						phone:'',
						text:'',
						isPush: false,
						captura: false,
					}
				} else {
					this.$eventHub.emit('snackBar', {message: 'Número inválido'})
				}

            },
            selecionaLayout(layout) {
                this.layout = layout
                return this.layout
            },
            selecionaContainer(container) {
                this.template.tipoContainer = container
                return this.template.tipoContainer
            },
            selecionaContainerCorpo(container) {
                this.template.tipoContainerCorpo = container
                return this.template.tipoContainerCorpo
            },
            selecionaBotao(opcao) {
                this.template.botao = opcao
                return this.template.botao
            },
			getSlug (text) {
				return makeSlug(text)
			},
			getValidaNumber (number) {
				return validaNumber(number)
			}
		},
		watch: {
			'novosms.text' () {
				this.novosms.text = this.getSlug(this.novosms.text)
			},
			textoMessage () {

			}
		}
  }
</script>






// WEBPACK FOOTER //
// src/components/user/push/EnvioPush.vue